// An ID is usable when it is a non-blank string or a finite number, and not the text "undefined", "null" or "NaN",
// which is what a template literal produces from a missing value. A numeric 0 is a valid ID.
export const normalizeId = (value: unknown) => (typeof value === 'string' ? value.trim() : value);

export const isUsableId = (value: unknown): boolean => {
  if (typeof value === 'number') return Number.isFinite(value);
  if (typeof value !== 'string') return false;
  const id = value.trim();
  return id !== '' && id !== 'undefined' && id !== 'null' && id !== 'NaN';
};
